import { InfoCardCompact, InfoCardCompactProps } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export interface IAttributes extends InfoCardCompactProps {
  mediaUrl: string
}

const InfoCardCompactBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return <InfoCardCompact {...attributes} icon={<img src={attributes.mediaUrl} alt="" width="100%" height="100%" />} />
}

export default InfoCardCompactBlock
